module.exports = __webpack_public_path__ + "static/media/Gilroy-Regular.11c5b356.woff2";